import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import {
  COLOR_WHITE,
  COLOR_LIME_GREEN,
  COLOR_RED,
  COLOR_BLUE,
  COLOR_ORANGE,
} from '../../assets/styles/colors';
import { BP_TABLET_MAX, BP_MOBILE_MAX, BP_NETBOOK_MAX } from '../../assets/styles/breakpoints';
import Tooltip from '../ui/tooltip';
import { SmallTextSC } from '../typography/small-text';

export default styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  ${({ withInvChart }) => (withInvChart ? '' : 'padding-bottom:32px')}

  .with-tooltip {
    display: flex;
    align-items: center;
  }
  ${SmallTextSC} .with-tooltip {
    line-height: 1.2;
  }

  .loading-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100px;
  }

  .left-wrap {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    min-width: 280px;

    &--main-headline {
      padding-top: 15px;
      padding-bottom: 0px;
    }
    button {
      margin-top: 12px;
      max-width: 195px;
    }
  }
  .right-wrap {
    width: 100%;

    &--top-infos {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      &__reinvest-switch {
        button {
          font-size: 14px;
          padding: 0px 10px;
          font-weight: 600;
          border-radius: 6px;
          border: none;
          color: rgb(209, 209, 214);
          background: #83828f;
          &:hover {
            filter: drop-shadow(0px 0px 2px #ffffff);
          }

          &.green {
            color: ${COLOR_LIME_GREEN};
            background: ${rgba(COLOR_LIME_GREEN, 0.2)};
            &:hover {
              background: hsl(167, 31%, 28%);
              filter: drop-shadow(0px 0px 3px hsla(144, 90%, 48%, 1));
            }
          }

          &.red {
            color: ${COLOR_RED};
            background: ${rgba(COLOR_RED, 0.2)};
            &:hover {
              background: hsl(336, 32%, 29%);
              filter: drop-shadow(0px 0px 3px hsla(0, 93%, 54%, 1));
            }
          }
        }
      }
    }
  }

  .main-stats-wrapper {
    display: flex;
    gap: 16px;

    .main-stats-col-wrapper {
      display: flex;
      flex-direction: column;
    }
    .left-inner-wrapper,
    .right-inner-wrapper {
      display: flex;
      flex-direction: column;
    }
    .right-inner-wrapper {
      width: 100%;
    }
  }

  @media (max-width: ${BP_TABLET_MAX}px) {
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    padding-bottom: 0px;

    .left-wrap {
      text-align: center;
      flex-wrap: wrap;

      &--main-headline {
        padding-top: 16px;
        padding-bottom: 0px;
      }

      button {
        text-align: center;
        margin: 12px auto 0 auto;
      }
    }
    .right-wrap {
      margin-top: 32px;
      width: 100%;
      max-width: 100%;

      .right-wrap--top-infos {
        justify-content: space-between;
      }

      .toggle-cards-wrapper {
        display: flex;
        gap: 20px;
        margin-bottom: 20px;

        > div {
          flex: 1;
        }

        h3 {
          font-weight: 700;
          font-size: 29px;
          line-height: 48px;
        }

        .col .col-content {
          padding: 5px 10px;
        }
      }
    }
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    align-items: flex-start;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding-bottom: 0px;
    .left-wrap {
      width: 100%;
      text-align: left;
      flex-wrap: wrap;
      padding-bottom: 24px;
      button {
        margin: 12px 0 0 0;
        max-width: 100%;
      }
    }

    .right-wrap {
      margin-top: 8px;
    }
  }

  @media (max-width: 1070px) {
    .left-wrap {
      min-width: 270px;
    }
  }

  @media (max-width: 515px) {
    .right-wrap {
      .toggle-cards-wrapper {
        flex-direction: column;
      }
    }
  }
`;

export const BannerMainStatsSC = styled.div`
  margin-top: 16px;
  display: flex;
  border-radius: 12px;
  padding: 17px 0;
  box-shadow: 0 8px 15px 0 #2f2e41;
  background-image: linear-gradient(to bottom, #434162, #403e5b 33%, #38364e);

  h3 {
    font-size: 24px;
    line-height: 40px;
  }

  &.banner-right {
    width: 100%;
    height: 100%;

    .col .col-content {
      padding-left: 5px;
    }
  }

  &.active {
    .col {
      width: calc(50% - 1px);

      @media (max-width: 1100px) {
        width: auto;
      }
    }
  }

  .evaluation {
    min-width: fit-content;
    white-space: nowrap;
  }
  .col {
    padding: 0px 16px;
    border-right: 1px solid ${rgba(COLOR_WHITE, 0.1)};
    white-space: nowrap;

    &.evaluation {
      width: 100%;
    }

    &.long-number {
      padding: 0px 9px;
    }

    &:last-child {
      border-right: none;
    }
    &.doubled {
      width: calc(50% - 1px);
      display: flex;
      flex-direction: column;
      small {
        &:nth-child(2) {
          padding-top: 5px;
        }
      }
      button {
        margin-top: 10px;
      }
    }
    .chart-wrap {
      display: flex;
      align-items: center;
      &--stats {
        padding-left: 10px;
        display: flex;
        flex-direction: column;
        height: 50px;
        justify-content: space-between;
        span {
          font-size: 12px;
          font-weight: bold;
          color: ${COLOR_BLUE};
        }
      }
    }

    @media (min-width: ${BP_TABLET_MAX + 1}px) and (max-width: 1070px) {
      padding-left: 10px;
      padding-right: 10px;

      .col-content {
        padding-left: 10px;
        padding-right: 10px;
      }
    }
  }

  .toggle-wrapper {
    .switch {
      position: relative;
      display: inline-block;
      width: 60px;
      height: 34px;
    }

    .switch input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #ccc;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }

    .slider:before {
      position: absolute;
      content: '';
      height: 26px;
      width: 26px;
      left: 4px;
      bottom: 4px;
      background-color: white;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }

    input:checked + .slider {
      background-color: #2196f3;
    }

    input:focus + .slider {
      box-shadow: 0 0 1px #2196f3;
    }

    input:checked + .slider:before {
      -webkit-transform: translateX(26px);
      -ms-transform: translateX(26px);
      transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
      border-radius: 34px;
    }

    .slider.round:before {
      border-radius: 50%;
    }
  }

  @media (max-width: 1260px) {
    h3 {
      font-size: 22px;
    }
  }

  @media (max-width: 1100px) {
    h3 {
      font-size: 19px;
      line-height: 48px;
    }
  }
`;

export const BannerSliderWrapSC = styled.div`
  .slick-slide {
    margin: 0px 10px;
  }
  /* the parent */
  .slick-list {
    margin: 0 -26px 0px -15px;
  }
  .slick-track {
    margin: 15px;
  }

  .bottom-cards-wrapper {
    display: flex;
  }
  .col {
    border-radius: 12px;
    box-shadow: 0 8px 15px 0 #2f2e41;
    min-height: 110px;
    padding: 17px 60px 17px 32px;
    background-image: linear-gradient(to bottom, #434162, #403e5b 33%, #38364e);
    white-space: nowrap;
    flex: 1;

    &.doubled {
      width: calc(75% - 1px);
      display: flex !important;
      flex-direction: column;
      small {
        &:nth-child(2) {
          padding-top: 5px;
        }
      }
      button {
        margin-top: 10px;
      }
    }
    .chart-wrap {
      display: flex;
      align-items: center;
      &--stats {
        padding-left: 10px;
        display: flex;
        flex-direction: column;
        height: 50px;
        justify-content: space-between;
        span {
          font-size: 12px;
          font-weight: bold;
          color: ${COLOR_BLUE};
        }
      }
    }
  }

  .bottom-cards-wrapper {
    display: flex;
    gap: 20px;
    margin-top: 16px;
  }

  @media (max-width: ${BP_TABLET_MAX}px) {
    .col {
      h3 {
        font-size: 23px;
        line-height: 32px;
      }
    }
  }

  @media (max-width: ${BP_MOBILE_MAX}px) {
    .slick-list {
      margin: 0 -10px 0px -15px;
    }

    .col {
      padding: 10px 16px 10px 16px;
      flex: initial;
      width: calc((100vw / 2) - 21px);
    }
  }

  @media (min-width: 516px) and (max-width: 560px) {
    .bottom-cards-wrapper {
      .col:nth-child(2) {
        min-width: 254px;
      }
    }
  }

  @media (max-width: 360px) {
    ${SmallTextSC} {
      font-size: 12px;
    }
    h3 {
      font-size: 20px;
    }

    .bottom-cards-wrapper {
      gap: 10px;
    }
  }
`;

export const ChartsWrapSC = styled.div`
  display: flex;
  @media (max-width: ${BP_TABLET_MAX}px) {
    flex-direction: column;
  }
`;

export const InvestChartWrapSC = styled.div`
  padding-bottom: 32px;
  width: 60%;
  padding-top: 32px;
  @media (max-width: ${BP_NETBOOK_MAX}px) {
    width: 60%;
  }
  @media (max-width: ${BP_TABLET_MAX}px) {
    width: 100%;
  }
`;

export const InvestCircleChartWrapSC = styled.div`
  padding-bottom: 32px;
  padding-left: 100px;
  width: 40%;
  padding-top: 32px;
  min-height: 370px;

  @media (max-width: ${BP_NETBOOK_MAX}px) {
    width: 40%;
    padding-left: 20px;
  }
  @media (max-width: ${BP_TABLET_MAX}px) {
    width: 100%;
    padding-left: 0px;
  }
`;

const hoverStyle = css`
  svg {
    circle {
      fill: ${COLOR_ORANGE};
    }
    text {
      fill: #434162;
    }
  }
`;

export const TooltipSC = styled(Tooltip)`
  opacity: 1;
  margin-top: ${({ marginTop }) => marginTop ?? undefined};

  &.tooltip-icon {
    display: flex;

    svg {
      circle {
        stroke: ${COLOR_ORANGE};
      }
      text {
        fill: ${COLOR_ORANGE};
      }
    }
    @media (hover: hover) {
      /* when supported */
      &:hover {
        ${hoverStyle}
      }
    }
    &.tooltip-visible {
      ${hoverStyle}
    }
  }
`;
